import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { stocksClient } from '../../../../../utils/apollo/api'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useUserStocksState = () => React.useContext(Context) || {}
export const useUserStocks = () => useUserStocksState()?.userStockItems || []

const QUERY = gql`
  query UserStockItems($page: Int, $sort: UserStockItemSort, $filter: UserStockItemFilter) {
    userStockItems(page: $page, sort: $sort, filter: $filter) {
      id
      amount
      user {
        id
        name
      }
    }
  }
`

const UserStocksLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const { id } = useModalData()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { stockItemId: id }
    },
    client: stocksClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default UserStocksLoader
